var map = {
	"./CallResultMailer/Locales/de_DE.json": "RTJB",
	"./CallResultMailer/Locales/en_US.json": "oxb4",
	"./CallResultMailer/Locales/hr_HR.json": "vfuX",
	"./Callcenter/Locales/de_DE.json": "FAja",
	"./Callcenter/Locales/en_US.json": "CwUM",
	"./Callcenter/Locales/hr_HR.json": "GWnF",
	"./Calls/Locales/de_DE.json": "A3ez",
	"./Calls/Locales/en_US.json": "z68c",
	"./Calls/Locales/hr_HR.json": "LmDy",
	"./Campaigns/Locales/de_DE.json": "R9c8",
	"./Campaigns/Locales/en_US.json": "jUsN",
	"./Campaigns/Locales/hr_HR.json": "fbP7",
	"./CustomerChat/Locales/de_DE.json": "QhSc",
	"./CustomerChat/Locales/en_US.json": "xc7h",
	"./CustomerChat/Locales/hr_HR.json": "UsYo",
	"./Dialer/Locales/de_DE.json": "lv+L",
	"./Dialer/Locales/en_US.json": "4ThS",
	"./Dialer/Locales/hr_HR.json": "F/z2",
	"./DoNotCall/Locales/hr_HR.json": "Qfyd",
	"./Events/Locales/de_DE.json": "uHlr",
	"./Events/Locales/en_US.json": "c1/x",
	"./Events/Locales/hr_HR.json": "hoGh",
	"./FacebookChat/Locales/de_DE.json": "ghb+",
	"./FacebookChat/Locales/en_US.json": "BAA8",
	"./FacebookChat/Locales/hr_HR.json": "O/Zx",
	"./GsmTrackers/Locales/de_DE.json": "WPHr",
	"./GsmTrackers/Locales/en_US.json": "IrJJ",
	"./GsmTrackers/Locales/hr_HR.json": "pomL",
	"./Mails/Locales/de_DE.json": "N8hu",
	"./Mails/Locales/en_US.json": "huJm",
	"./Mails/Locales/hr_HR.json": "HaL7",
	"./Menu/Locales/de_DE.json": "lwDR",
	"./Menu/Locales/en_US.json": "mddp",
	"./Menu/Locales/hr_HR.json": "brY+",
	"./Pauses/Locales/hr_HR.json": "3kYb",
	"./Phonebook/Locales/de_DE.json": "AyUP",
	"./Phonebook/Locales/en_US.json": "35NU",
	"./Phonebook/Locales/hr_HR.json": "b7zo",
	"./Player/Locales/de_DE.json": "fA84",
	"./Player/Locales/en_US.json": "WkY2",
	"./Player/Locales/hr_HR.json": "p5lM",
	"./Polls/Locales/de_DE.json": "9fIt",
	"./Polls/Locales/en_US.json": "pxlA",
	"./Polls/Locales/hr_HR.json": "Ktsx",
	"./Queues/Locales/de_DE.json": "W50s",
	"./Queues/Locales/en_US.json": "bNBL",
	"./Queues/Locales/hr_HR.json": "EBNb",
	"./Reporting/Locales/de_DE.json": "FIH2",
	"./Reporting/Locales/en_US.json": "xHmt",
	"./Reporting/Locales/hr_HR.json": "FmgW",
	"./Settings/Locales/de_DE.json": "eScI",
	"./Settings/Locales/en_US.json": "88aJ",
	"./Settings/Locales/hr_HR.json": "7EL+",
	"./Sms/Locales/en_US.json": "Aunv",
	"./Sms/Locales/hr_HR.json": "YrRH",
	"./Ticketing/Locales/de_DE.json": "dwu0",
	"./Ticketing/Locales/en_US.json": "uVP/",
	"./Ticketing/Locales/hr_HR.json": "Tj8G",
	"./User/Locales/de_DE.json": "vV4+",
	"./User/Locales/en_US.json": "U2yz",
	"./User/Locales/hr_HR.json": "EXCN",
	"./Voicemails/Locales/de_DE.json": "h92B",
	"./Voicemails/Locales/en_US.json": "oTIr",
	"./Voicemails/Locales/hr_HR.json": "njpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5Q1Q";